<template>
  <v-app id="app">
    <ToolBar/>
    <v-main id="appContent">
      <v-container fluid>
        <router-view :key="$route.fullPath"/>
      </v-container>
    </v-main>
    <Footer/>
  </v-app>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import 'vuetify/dist/vuetify.min.css'
import VueMatomo from "vue-matomo";
import ToolBar from "@/components/ToolBar.vue";

import {ImageApi, ImageCollectionDto} from "@swagger";
import BasicComponent from "@/global/BasicComponent";
import Footer from "@/components/Footer.vue";
import {Watch} from "vue-property-decorator";
import HelpBubble from "@/components/HelpBubble.vue";

@Component({
  components: {HelpBubble, Footer, ToolBar}
})
export default class App extends BasicComponent {

  created() {
    try {
      this.registerAnalytics();
    } catch (e) {
      console.error("Error while registering analytics", e);
    }
    if (this.stepSet) {
      this.setStep(this.$route.query.step, true, false);
    } else {
      this.setStep(1, false, false);
    }

    new ImageApi(this.apiConfiguration).getImages()
        .then((data: ImageCollectionDto) => {
          this.$store.commit("setImageSelection", data);
          if (this.mayAutoSwitchStep()) {
            if (data.images.length > 0) {
              if (! this.stepSet) {
                this.setStep(3);
              }
            } else {
              this.setStep(1);
            }
          }
        })
        .catch((err) => {
          err.json().then(error => {
            console.error(error.message);
            this.setStep(1); // Return to code insertion
            //this.errorMessage = error.message;
          });
        });

    this.requestProducts();
    this.requestProductCategories();
    this.getBasketData();
    this.requestCoupons();

    this.onRouteChange(this.$route, null);
  }

  registerAnalytics() {
    const router = this.$router;

    Vue.use(VueMatomo, {
      siteId: 3,
      host: "https://analytics.gngn.at",
      disableCookies: true,
    });
    /*
    Vue.use(VueAnalytics, {
      id: this.$t("gaId").toString(),
      router,
      set: [
        {field: 'anonymizeIp', value: true}
      ],
      autoTracking: {
        pageviewOnLoad: false,
        page: false
      },
      debug: {
        enabled: false, // default value
        trace: false, // default value
        sendHitTask: true // default value
      }
    });
    this.track();
     */
  }

  track() {
    //this["$ga"].screenview("home");
  }

  shouldRerender() { // Step 2 should always be rerendered
    const should = this.$route.path === "/" && String(this.$route.query.step) === "2";
    return should + "";
  }

  /**
   * Whether to automatically navigate to the latest available step or stay at the current step
   */
  mayAutoSwitchStep(): boolean {
    if (Number(this.$route.query.step) === 1) return false;
    return true;
  }

  @Watch("$route")
  onRouteChange(to, from) {
    window.scrollTo(0, 0);
  }

}

function getHost() {
  return window.location.host;
}


document.addEventListener("touchstart", function () {
}, true);

</script>
<style lang="scss">
@use "./stylesheets/Theme.scss" as *;
@use "./stylesheets/Variables.scss" as *;

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &:focus {
    outline: none;
  }
}

html {
  max-width: 100vw;

  position: relative;
  overflow-x: hidden;

  font-family: $fontFamily;
}

body {
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  min-height: 50vw;
  max-width: 100vw;
  margin: 0;
}

#rootLayout {
  width: 100%;
  height: 90%;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 25px;
}

.dontBreakOut {
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;

  & a {
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
  }
}

button {
  .v-icon, .v-progress-circular {
    margin-right: 10px;
  }
}

.shrink {
  flex: 0 1 auto;
}

p:not(:last-of-type) {
  margin-bottom: 0;
}

.grecaptcha-badge {
  z-index: 60;
}

.priceTag {
  color: rgb(68, 138, 255) !important;
  font-size: 16px;
}

.whiteCard {
  box-shadow: 0 3px 3px -2px rgba(0, 0, 0, .2), 0 3px 4px 0 rgba(0, 0, 0, .14), 0 1px 8px 0 rgba(0, 0, 0, .12) !important;
  background-color: white;
  border-radius: 3px;
  padding: 20px;
}

.ql-indent-1 {
  margin-left: 20px;
}

.ql-indent-2 {
  margin-left: 40px;
}

</style>
